export default "__VITE_ASSET__09fefb36__"